(function($) {

  $('#dropdownButton').on('click', function (e) {
    e.stopPropagation(); // evita que se cierre al hacer click en el botón
    $('#dropdownMenu').toggleClass('hidden');
  });

  $(document).on('click', function () {
    $('#dropdownMenu').addClass('hidden'); // cierra si haces clic fuera
  });

})(window.jQuery);
